import styled from 'styled-components';
import {
  COLOR_BLACK,
  COLOR_BLUE,
  COLOR_BLUE_050,
} from '@common/assets/styles/colors';
import PAGE_STYLES from '../../helpers/page-styles';

export default styled.div`
  ${PAGE_STYLES};

  .header {
    h4 {
      color: ${COLOR_BLACK};
      font-weight: bold;
      line-height: 20px;
    }
  }

  label {
    color: ${COLOR_BLUE};
    line-height: 20px;
    margin-bottom: 8px;
  }

  span {
    text-align: center;
    width: 100%;
    display: block;
    margin-top: 20px;
    font-size: 14px;
    line-height: 21px;
  }

  > button {
    margin-bottom: 16px;
  }

  div.error-box {
    display: inline-block;
  }

  input {
    ::placeholder {
      color: ${COLOR_BLUE_050};
    }
  }
`;
